import { render } from "./SelectAccounts.vue?vue&type=template&id=42ab6d07&scoped=true&ts=true"
import script from "./SelectAccounts.vue?vue&type=script&lang=ts"
export * from "./SelectAccounts.vue?vue&type=script&lang=ts"

import "./SelectAccounts.vue?vue&type=style&index=0&id=42ab6d07&scoped=true&lang=scss"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ab6d07"]])

export default __exports__